import(/* webpackMode: "eager", webpackExports: ["PromoPageComp"] */ "/vercel/path0/src/components/promoPage/promoPageComp.tsx");
